import styled from "styled-components";

export const WithdrawalLimitsModalContainerStyled = styled.div`
    display: flex;
    overflow: auto;
    max-height: 70vh;
    padding: 0 24px 24px;
`;
